import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WindowRefService {
  constructor(@Inject(DOCUMENT) private readonly document: Document) {}

  private get nativeWindow(): Window {
    return this.document.defaultView as Window;
  }

  reload(): void {
    this.nativeWindow.location.reload();
  }

  navigateTo(url: string): void {
    this.nativeWindow.location.href = url;
  }
}
